module.exports = __webpack_public_path__ + "img/banner1@2x.686de55b.png";